import { fetchData } from "@utils/api";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { TagExtendedNewDto, tagExtendedNewSchema } from "@client";
import * as yup from "yup";

export const fetchCreatorMealTags = async (
  mealId: string,
): Promise<ApiResponse<TagExtendedNewDto[]>> => {
  const response = await fetchData(
    `/dietitian/creator/meals/${mealId}/tags`,
    APIMethods.GET,
  );

  return apiResponseSchema.validate(response);
};

const apiResponseSchema = yup.object().shape({
  data: yup.array().of(tagExtendedNewSchema).required(),
});
